"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var knownExamples = {};
exports.registerExamples = function (examples) {
    examples.forEach(function (example) { return (knownExamples[example.name] = example); });
};
exports.getExamples = function () {
    return Object.keys(knownExamples).map(function (key) { return knownExamples[key]; });
};
//# sourceMappingURL=register.js.map